import Cookies from 'js-cookie';

export function isAuthenticated() {
  var timestamp = parseFloat(Cookies.get('is_authenticated')) * 1000;
  return (!isNaN(timestamp) && timestamp > Date.now());
}
